// extracted by mini-css-extract-plugin
export var content = "TwoColumnSection-module--content--c40e3";
export var holder = "TwoColumnSection-module--holder--b3045";
export var title = "TwoColumnSection-module--title--ee0c7";
export var wrapper = "TwoColumnSection-module--wrapper--1db62";